export const lives = [
  {
    id: "g1",
    title: "巅峰赛 2000 分冲榜赛，今晚必上王者",
    streamer: "峡谷之巅·阿凯",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20confident%20young%20male%20esports%20streamer%20wearing%20a%20gaming%20headset%2C%20clean%20soft%20blue%20studio%20background%2C%20modern%20friendly%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-s1&orientation=squarish",
    channel: "game",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20modern%20esports%20livestream%20cover%20art%2C%20epic%20battle%20arena%20with%20glowing%20knight%20armor%20and%20crossed%20swords%2C%20dark%20blue%20gradient%20background%20with%20electric%20sparks%2C%20cinematic%20neon%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=cover-g1&orientation=landscape",
    viewers: 128500,
    status: "online",
    type: "竞技",
    level: "S级",
    tags: ["王者荣耀", "冲榜", "巅峰赛"],
    startedAt: "今天 20:00",
    desc: "本周冲分关键局，主打打野节奏运营，全程语音讲解思路，欢迎评论区一起复盘每一波团战。",
    hot: true,
  },
  {
    id: "g2",
    title: "枪王之王 排位连麦飙分",
    streamer: "爆头教官·老K",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20focused%20male%20fps%20gamer%20with%20headset%2C%20clean%20soft%20dark%20studio%20background%2C%20modern%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-g2&orientation=squarish",
    channel: "game",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20modern%20fps%20shooter%20livestream%20cover%20art%2C%20crosshair%20and%20tactical%20gear%2C%20dark%20navy%20gradient%20background%20with%20orange%20muzzle%20flashes%2C%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=cover-g2&orientation=landscape",
    viewers: 96200,
    status: "online",
    type: "竞技",
    level: "A级",
    tags: ["FPS", "排位", "枪法教学"],
    startedAt: "今天 19:30",
    desc: "枪法教学 + 高分排位实战，从压枪、预瞄到身法节奏，边打边讲，新手也能听懂。",
    hot: true,
  },
  {
    id: "g3",
    title: "英雄联盟 韩服大师局实况",
    streamer: "峡谷琴女",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20calm%20young%20female%20moba%20gamer%20with%20headset%2C%20clean%20soft%20blue%20studio%20background%2C%20modern%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-g3&orientation=squarish",
    channel: "game",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20modern%20moba%20strategy%20livestream%20cover%20art%2C%20fantasy%20battlefield%20with%20glowing%20magic%20runes%2C%20deep%20blue%20gradient%20background%2C%20cinematic%20neon%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=cover-g3&orientation=landscape",
    viewers: 54300,
    status: "online",
    type: "竞技",
    level: "A级",
    tags: ["英雄联盟", "韩服", "大师局"],
    startedAt: "今天 18:00",
    desc: "韩服大师分段实录，版本强势英雄出装思路与对线细节，弹幕点将想看的英雄即可。",
    hot: false,
  },
  {
    id: "g4",
    title: "Switch 新游首发开荒体验",
    streamer: "手柄小王子",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20happy%20young%20male%20console%20gamer%20holding%20a%20controller%2C%20clean%20soft%20purple%20studio%20background%2C%20modern%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-g4&orientation=squarish",
    channel: "game",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20modern%20console%20gaming%20livestream%20cover%20art%2C%20colorful%20game%20controller%20and%20adventure%20world%20backdrop%2C%20soft%20gradient%20background%2C%20playful%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=cover-g4&orientation=landscape",
    viewers: 23800,
    status: "online",
    type: "娱乐",
    level: "B级",
    tags: ["主机游戏", "新游", "开荒"],
    startedAt: "今天 21:00",
    desc: "首发当日第一时间开荒，全程无剧透体验向，聊聊画面表现、手柄手感与玩法亮点。",
    hot: false,
  },
  {
    id: "g5",
    title: "绝地求生 四排吃鸡欢乐场",
    streamer: "钢枪小队",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20cheerful%20young%20male%20battle%20royale%20gamer%2C%20clean%20soft%20olive%20studio%20background%2C%20modern%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-g5&orientation=squarish",
    channel: "game",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20modern%20battle%20royale%20livestream%20cover%20art%2C%20parachute%20and%20desert%20map%20silhouette%2C%20warm%20orange%20gradient%20background%2C%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=cover-g5&orientation=landscape",
    viewers: 18700,
    status: "replay",
    type: "娱乐",
    level: "B级",
    tags: ["PUBG", "四排", "吃鸡"],
    startedAt: "昨天 21:30",
    desc: "欢乐四排整活局，全程高能翻盘集锦，昨晚的精彩回放已上线，错过直播的朋友别错过。",
    hot: false,
  },
  {
    id: "g6",
    title: "高难副本速通攻略教学",
    streamer: "理智博士",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20thoughtful%20young%20male%20gamer%20with%20glasses%2C%20clean%20soft%20teal%20studio%20background%2C%20modern%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-g6&orientation=squarish",
    channel: "game",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20modern%20anime%20rpg%20livestream%20cover%20art%2C%20dungeon%20gate%20with%20glowing%20crystals%2C%20deep%20teal%20gradient%20background%2C%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=cover-g6&orientation=landscape",
    viewers: 12600,
    status: "online",
    type: "教学",
    level: "A级",
    tags: ["二次元", "攻略", "速通"],
    startedAt: "今天 20:30",
    desc: "本期攻略新版本高难副本，配队站位与技能循环逐帧拆解，附带低配替代方案。",
    hot: false,
  },
  {
    id: "e1",
    title: "深夜脱口秀：这周的热梗都在这",
    streamer: "甜心小鹿",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20cheerful%20young%20female%20live%20streamer%20with%20a%20bright%20smile%2C%20clean%20soft%20warm%20studio%20background%2C%20modern%20friendly%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-s2&orientation=squarish",
    channel: "entertainment",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20modern%20talk%20show%20livestream%20cover%20art%2C%20retro%20microphone%20and%20neon%20sign%2C%20warm%20pink%20orange%20gradient%20background%2C%20playful%20stage%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=cover-e1&orientation=landscape",
    viewers: 210300,
    status: "online",
    type: "娱乐",
    level: "S级",
    tags: ["脱口秀", "热梗", "连麦"],
    startedAt: "今天 22:00",
    desc: "一周热梗大盘点，配合弹幕投稿现场开麦，笑点密集，睡前解压首选。",
    hot: true,
  },
  {
    id: "e2",
    title: "才艺连麦 PK 大乱斗之夜",
    streamer: "会跳舞的猫",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20an%20energetic%20young%20female%20dancer%20streamer%2C%20clean%20soft%20pink%20studio%20background%2C%20modern%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-e2&orientation=squarish",
    channel: "entertainment",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20modern%20talent%20show%20livestream%20cover%20art%2C%20dancers%20silhouette%20with%20stage%20spotlights%2C%20magenta%20gradient%20background%2C%20energetic%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=cover-e2&orientation=landscape",
    viewers: 88700,
    status: "online",
    type: "娱乐",
    level: "A级",
    tags: ["才艺", "连麦PK", "舞蹈"],
    startedAt: "今天 21:30",
    desc: "跨频道才艺连麦 PK，舞蹈、唱歌、乐器轮番上阵，弹幕刷礼物为喜欢的主播打 call。",
    hot: true,
  },
  {
    id: "e3",
    title: "古风 cos 变装派对",
    streamer: "洛水卿卿",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20an%20elegant%20young%20female%20cosplay%20streamer%2C%20clean%20soft%20rose%20studio%20background%2C%20modern%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-e3&orientation=squarish",
    channel: "entertainment",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20modern%20guofeng%20cosplay%20livestream%20cover%20art%2C%20elegant%20silk%20ribbons%20and%20lanterns%2C%20rose%20red%20gradient%20background%2C%20soft%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=cover-e3&orientation=landscape",
    viewers: 61200,
    status: "online",
    type: "娱乐",
    level: "A级",
    tags: ["古风", "cosplay", "变装"],
    startedAt: "今天 20:00",
    desc: "汉服古风变装专场，逐套展示妆造细节，聊服装形制与拍摄幕后小故事。",
    hot: false,
  },
  {
    id: "e4",
    title: "户外探店：城市深夜食堂",
    streamer: "夜行者阿彪",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20friendly%20young%20male%20travel%20vlogger%20with%20backpack%2C%20clean%20soft%20amber%20studio%20background%2C%20modern%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-e4&orientation=squarish",
    channel: "entertainment",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20modern%20city%20night%20food%20street%20livestream%20cover%20art%2C%20glowing%20neon%20signs%20and%20food%20stalls%2C%20warm%20amber%20gradient%20background%2C%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=cover-e4&orientation=landscape",
    viewers: 34800,
    status: "online",
    type: "娱乐",
    level: "B级",
    tags: ["户外", "探店", "美食"],
    startedAt: "今天 23:00",
    desc: "带你云逛城市深夜小吃街，边吃边聊，随机探店不接受赞助，真实测评。",
    hot: false,
  },
  {
    id: "e5",
    title: "沉浸式开箱 手办潮玩专场",
    streamer: "拆盒少女",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20an%20excited%20young%20female%20collector%20streamer%2C%20clean%20soft%20mint%20studio%20background%2C%20modern%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-e5&orientation=squarish",
    channel: "entertainment",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20modern%20unboxing%20livestream%20cover%20art%2C%20colorful%20designer%20toy%20figures%20and%20boxes%2C%20mint%20gradient%20background%2C%20playful%20studio%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=cover-e5&orientation=landscape",
    viewers: 15900,
    status: "replay",
    type: "娱乐",
    level: "B级",
    tags: ["开箱", "手办", "潮玩"],
    startedAt: "前天 20:30",
    desc: "本周潮玩开箱回放，限定款与盲盒隐藏款一次性拆个够，附送收纳与陈列小技巧。",
    hot: false,
  },
  {
    id: "ed1",
    title: "雅思口语 8 分训练营 第 12 讲",
    streamer: "名师 Emily",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20professional%20female%20english%20teacher%20with%20glasses%2C%20clean%20soft%20neutral%20studio%20background%2C%20modern%20friendly%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-s3&orientation=squarish",
    channel: "education",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20modern%20language%20class%20livestream%20cover%20art%2C%20open%20books%20and%20speech%20bubbles%2C%20soft%20blue%20gradient%20background%2C%20clean%20modern%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=cover-ed1&orientation=landscape",
    viewers: 76500,
    status: "online",
    type: "教学",
    level: "S级",
    tags: ["雅思", "口语", "英语"],
    startedAt: "今天 19:00",
    desc: "Part 2 话题卡片高分表达模板，现场示范答题节奏，附带发音纠正与连读技巧。",
    hot: true,
  },
  {
    id: "ed2",
    title: "Python 实战：从零做一个爬虫",
    streamer: "代码老王",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20friendly%20male%20programmer%20with%20glasses%2C%20clean%20soft%20blue%20studio%20background%2C%20modern%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-ed2&orientation=squarish",
    channel: "education",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20modern%20programming%20course%20livestream%20cover%20art%2C%20code%20editor%20screen%20with%20glowing%20brackets%2C%20deep%20blue%20gradient%20background%2C%20clean%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=cover-ed2&orientation=landscape",
    viewers: 58900,
    status: "online",
    type: "教学",
    level: "A级",
    tags: ["Python", "编程", "爬虫"],
    startedAt: "今天 20:30",
    desc: "面向零基础，从环境搭建到抓取第一个网页，边写边讲，配套源码课后发放。",
    hot: true,
  },
  {
    id: "ed3",
    title: "考研数学冲刺 高数重点串讲",
    streamer: "数学张老师",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20patient%20male%20math%20teacher%20with%20chalk%2C%20clean%20soft%20green%20studio%20background%2C%20modern%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-ed3&orientation=squarish",
    channel: "education",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20modern%20math%20exam%20livestream%20cover%20art%2C%20chalkboard%20with%20geometry%20figures%2C%20soft%20green%20gradient%20background%2C%20clean%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=cover-ed3&orientation=landscape",
    viewers: 42300,
    status: "online",
    type: "教学",
    level: "A级",
    tags: ["考研", "高等数学", "冲刺"],
    startedAt: "今天 19:30",
    desc: "冲刺阶段高频考点串讲，极限、级数与曲线积分逐个击破，配套典型例题详解。",
    hot: false,
  },
  {
    id: "ed4",
    title: "职场沟通课：高效汇报技巧",
    streamer: "职场教练 Ryan",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20confident%20male%20career%20coach%20in%20a%20shirt%2C%20clean%20soft%20slate%20studio%20background%2C%20modern%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-ed4&orientation=squarish",
    channel: "education",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20modern%20business%20skills%20livestream%20cover%20art%2C%20presentation%20charts%20and%20handshake%20motif%2C%20slate%20blue%20gradient%20background%2C%20clean%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=cover-ed4&orientation=landscape",
    viewers: 21600,
    status: "replay",
    type: "教学",
    level: "B级",
    tags: ["职场", "沟通", "汇报"],
    startedAt: "昨天 20:00",
    desc: "回放已上线：向上汇报的三段式结构、数据讲故事技巧，帮你把话说到点子上。",
    hot: false,
  },
  {
    id: "lf1",
    title: "深夜厨房：一锅炖出幸福感",
    streamer: "林师傅",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20friendly%20middle%20aged%20male%20chef%20in%20an%20apron%2C%20clean%20soft%20warm%20studio%20background%2C%20modern%20friendly%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-s6&orientation=squarish",
    channel: "life",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20modern%20cooking%20livestream%20cover%20art%2C%20steaming%20hot%20pot%20on%20a%20stove%20with%20fresh%20ingredients%2C%20warm%20amber%20gradient%20background%2C%20cozy%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=cover-lf1&orientation=landscape",
    viewers: 45300,
    status: "online",
    type: "娱乐",
    level: "A级",
    tags: ["美食", "家常菜", "深夜食堂"],
    startedAt: "今天 22:30",
    desc: "一锅端的家常炖菜教程，选料、火候、调味全流程演示，新手也能一次成功。",
    hot: true,
  },
  {
    id: "lf2",
    title: "手工皮具制作全流程",
    streamer: "匠人小赵",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20focused%20young%20male%20craftsman%20in%20a%20workshop%2C%20clean%20soft%20brown%20studio%20background%2C%20warm%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-lf2&orientation=squarish",
    channel: "life",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20modern%20handmade%20leather%20craft%20livestream%20cover%20art%2C%20leather%20tools%20and%20wallet%20on%20workbench%2C%20warm%20brown%20gradient%20background%2C%20cozy%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=cover-lf2&orientation=landscape",
    viewers: 18300,
    status: "online",
    type: "教学",
    level: "B级",
    tags: ["手工", "皮具", "DIY"],
    startedAt: "今天 20:00",
    desc: "从裁皮、打孔到缝线收边，完整制作一只卡包，工具使用与常见问题一并讲解。",
    hot: false,
  },
  {
    id: "lf3",
    title: "阳台种菜日记 第 30 天",
    streamer: "城市农夫",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20cheerful%20young%20female%20urban%20gardener%2C%20clean%20soft%20green%20studio%20background%2C%20modern%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-lf3&orientation=squarish",
    channel: "life",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20modern%20balcony%20gardening%20livestream%20cover%20art%2C%20potted%20vegetables%20and%20greenery%2C%20fresh%20green%20gradient%20background%2C%20sunny%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=cover-lf3&orientation=landscape",
    viewers: 12800,
    status: "online",
    type: "娱乐",
    level: "B级",
    tags: ["种菜", "阳台", "生活"],
    startedAt: "今天 18:30",
    desc: "阳台小菜园第 30 天记录，定植、施肥与病虫害处理，小空间也能有收获。",
    hot: false,
  },
  {
    id: "sp1",
    title: "NBA 焦点战 赛前分析直播",
    streamer: "篮球评论员大鹏",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20an%20energetic%20male%20sports%20commentator%20wearing%20a%20headset%2C%20clean%20soft%20neutral%20studio%20background%2C%20modern%20friendly%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-s5&orientation=squarish",
    channel: "sports",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20modern%20basketball%20game%20livestream%20cover%20art%2C%20glowing%20basketball%20and%20arena%20lights%2C%20orange%20blue%20gradient%20background%2C%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=cover-sp1&orientation=landscape",
    viewers: 92300,
    status: "online",
    type: "竞技",
    level: "S级",
    tags: ["NBA", "篮球", "解说"],
    startedAt: "今天 09:00",
    desc: "焦点战赛前深度分析，双方阵容、战术克制与关键球员状态，赛后还有即时复盘。",
    hot: true,
  },
  {
    id: "sp2",
    title: "欧冠淘汰赛 赛后复盘",
    streamer: "足球老炮",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20passionate%20male%20football%20pundit%20with%20a%20microphone%2C%20clean%20soft%20green%20studio%20background%2C%20modern%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-sp2&orientation=squarish",
    channel: "sports",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20modern%20football%20champions%20league%20livestream%20cover%20art%2C%20stadium%20pitch%20and%20glowing%20football%2C%20green%20gradient%20background%2C%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=cover-sp2&orientation=landscape",
    viewers: 54700,
    status: "online",
    type: "竞技",
    level: "A级",
    tags: ["欧冠", "足球", "复盘"],
    startedAt: "今天 06:00",
    desc: "淘汰赛次日复盘，进攻套路、防守漏洞与争议判罚逐回合拆解，欢迎弹幕来辩。",
    hot: false,
  },
  {
    id: "sp3",
    title: "综合格斗之夜 赛前预测",
    streamer: "铁笼解说",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20tough%20male%20mma%20commentator%2C%20clean%20soft%20dark%20studio%20background%2C%20modern%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-sp3&orientation=squarish",
    channel: "sports",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20modern%20mma%20fighting%20livestream%20cover%20art%2C%20spotlight%20octagon%20ring%2C%20dark%20red%20gradient%20background%2C%20dramatic%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=cover-sp3&orientation=landscape",
    viewers: 28900,
    status: "replay",
    type: "竞技",
    level: "A级",
    tags: ["综合格斗", "赛事", "预测"],
    startedAt: "昨天 22:00",
    desc: "主赛卡逐场预测回放，选手技战术特点与胜负手分析，附带赔率解读与看点提示。",
    hot: false,
  },
  {
    id: "mu1",
    title: "深夜古风翻唱，点歌不停",
    streamer: "星河不夜",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20an%20artistic%20young%20male%20singer%20holding%20a%20microphone%2C%20clean%20soft%20indigo%20studio%20background%2C%20modern%20friendly%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-s4&orientation=squarish",
    channel: "music",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20modern%20music%20singing%20livestream%20cover%20art%2C%20glowing%20microphone%20and%20sound%20waves%2C%20deep%20indigo%20gradient%20background%2C%20moody%20stage%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=cover-mu1&orientation=landscape",
    viewers: 134200,
    status: "online",
    type: "娱乐",
    level: "S级",
    tags: ["古风", "翻唱", "点歌"],
    startedAt: "今天 23:00",
    desc: "深夜点歌专场，古风与流行翻唱无缝切换，用声音陪你度过每一个加班的夜晚。",
    hot: true,
  },
  {
    id: "mu2",
    title: "Livehouse 现场：民谣小专场",
    streamer: "木吉他阿杰",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20laid%20back%20young%20male%20guitarist%20with%20an%20acoustic%20guitar%2C%20clean%20soft%20amber%20studio%20background%2C%20warm%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-mu2&orientation=squarish",
    channel: "music",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20modern%20acoustic%20folk%20live%20livestream%20cover%20art%2C%20acoustic%20guitar%20under%20warm%20string%20lights%2C%20amber%20gradient%20background%2C%20cozy%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=cover-mu2&orientation=landscape",
    viewers: 47800,
    status: "online",
    type: "娱乐",
    level: "A级",
    tags: ["民谣", "现场", "吉他"],
    startedAt: "今天 21:00",
    desc: "小场地民谣专场直播，原创与翻唱交织，聊聊每首歌背后的故事与创作灵感。",
    hot: false,
  },
  {
    id: "mu3",
    title: "钢琴即兴演奏 陪你加班",
    streamer: "琴键上的月光",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20graceful%20young%20female%20pianist%2C%20clean%20soft%20lavender%20studio%20background%2C%20modern%20lighting%2C%20high%20detail&width=400&height=400&seq=avatar-mu3&orientation=squarish",
    channel: "music",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20modern%20piano%20music%20livestream%20cover%20art%2C%20grand%20piano%20keys%20with%20glowing%20notes%2C%20soft%20lavender%20gradient%20background%2C%20elegant%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=cover-mu3&orientation=landscape",
    viewers: 33100,
    status: "online",
    type: "娱乐",
    level: "A级",
    tags: ["钢琴", "即兴", "轻音乐"],
    startedAt: "今天 22:00",
    desc: "安静的钢琴即兴时段，适合学习与加班时当作背景音，弹幕可点歌或留言心情。",
    hot: false,
  },
];